import {
  TableauFilter,
  TableauFilterSelection,
} from "@/components/tableau/types"
import {
  applyFilterToWorksheet,
  formatFilterData,
} from "@/components/tableau/utils"
import { useCallback, useEffect, useState } from "react"

export function useTableauFilters(vizRef: React.MutableRefObject<any | null>) {
  const [filters, setFilters] = useState<TableauFilter[]>([])
  const [selectedFilters, setSelectedFilters] =
    useState<TableauFilterSelection>({})

  const getAllFilterValues = useCallback(async () => {
    if (!vizRef.current) return

    const workbook = vizRef.current.workbook
    const worksheet = workbook.activeSheet

    try {
      const filters = await worksheet.getFiltersAsync()
      console.log("FILTERS from getFiltersAsync =>", filters)

      const filterValues = await Promise.all(filters.map(formatFilterData))

      const filteredValues = filterValues.filter(
        (filterValue) => filterValue.values.length !== 0
      )

      console.log("Filter values: ", filterValues)
      setFilters(filteredValues)
      return filteredValues
    } catch (error) {
      console.error("Error getting filters:", error)
      return []
    }
  }, [vizRef])

  const updateFilterSelection = useCallback(
    (
      fieldName: string,
      selectedValues: string[],
      selectedGroups: string[] = []
    ) => {
      setSelectedFilters((prev) => ({
        ...prev,
        [fieldName]: {
          selectedFilter: selectedValues,
          selectedGroup: selectedGroups,
        },
      }))
    },
    []
  )

  const applyFilters = useCallback(async () => {
    if (!vizRef.current) return

    try {
      const workbook = vizRef.current.workbook
      const worksheet = workbook.activeSheet

      // Iterate through selected filters
      for (const [fieldName, filterData] of Object.entries(selectedFilters)) {
        if (filterData.selectedFilter.length > 0) {
          await applyFilterToWorksheet(
            worksheet,
            fieldName,
            filterData.selectedFilter
          )
        }
      }
    } catch (error) {
      console.error("Error applying filters:", error)
    }
  }, [selectedFilters, vizRef])

  useEffect(() => {
    if (vizRef.current && Object.keys(selectedFilters).length > 0) {
      applyFilters()
    }
  }, [selectedFilters, applyFilters])

  return {
    filters,
    selectedFilters,
    getAllFilterValues,
    updateFilterSelection,
  }
}
